export type ContactWayType = 'messenger' | 'other'

export interface IContactWayData {
  readonly id?: number
  name?: string
  readonly type?: ContactWayType
}

export interface IContactWay extends IContactWayData {
  readonly id: number
  name: string
  readonly type: ContactWayType

  validate(): boolean
  update(data?: IContactWayData): void
}

export const CONTACT_WAY_NAME_MAX_LENGTH = 30;
